/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REPORT DETAILS : AREA : METRICS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	metrics: {
		'& .metrics-options': {
			margin: replacePXinStringWithEM('15px 10px'),
			'& .list-item .option-text': {
				opacity: 1
			}
		}
	}
});